import {VIOLATION_LIST_RESET, VIOLATION_LIST_SET} from './mutation-types';


const getDefaultState = () => {
    return {
        items: {},
    };
};
const state = getDefaultState();

const getters = {
    violations: state => state.items
};

const mutations = {
    [VIOLATION_LIST_SET](state, violations) {
        state.items = violations;
    },
    [VIOLATION_LIST_RESET](state) {
        Object.assign(state, getDefaultState());
    },
};

const loader = {
    namespaced: true,
    state,
    getters,
    mutations,
};

export default loader;



// WEBPACK FOOTER //
// ./src/store/modules/violation/list.js